import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { Navigate, useParams } from 'react-router-dom'
import { RequirementDetailProvider } from './context/RequirementDetailProvider'
import { RequirementDetailWorkflowsProvider } from './context/RequirementDetailWorkflowProvider'
import { RequirementDetailMain } from './RequirementDetailMain'
import { EditQuestionFlow } from './workflows/EditQuestionFlow'
import { RemoveQuestionFlow } from './workflows/RemoveQuestionFlow'
import { RestoreQuestionFlow } from './workflows/RestoreQuestionFlow'

export const RequirementDetail = () => {
  const { requirementId } = useParams()

  if (!requirementId || isNaN(Number(requirementId))) {
    return <Navigate to="/not-found" />
  }

  return (
    <NuqsAdapter>
      <RequirementDetailProvider requirementId={Number(requirementId)}>
        <RequirementDetailWorkflowsProvider>
          <RequirementDetailMain />
          <EditQuestionFlow />
          <RemoveQuestionFlow />
          <RestoreQuestionFlow />
        </RequirementDetailWorkflowsProvider>
      </RequirementDetailProvider>
    </NuqsAdapter>
  )
}
